import { useEffect, useState } from 'react'
import { SwitchingStoreRefType } from 'types/auth'

const useSwitchStoreName = (switchingStoreRef: SwitchingStoreRefType): string => {
  const [storeName, setStoreName] = useState<string>('')
  useEffect(() => {
    if (!switchingStoreRef) return
    switchingStoreRef.store_ref.get().then(async (snapshot) => {
      const data = snapshot.data()
      if (!data || !('name' in data)) return
      // SSスタッフへの切り替えの場合
      if (switchingStoreRef.is_event_staff) {
        setStoreName(`${data.name}（スタッフ用）`)
      } else if (typeof switchingStoreRef.manufacturer_ref !== 'undefined') {
        const manufacturerName = await switchingStoreRef.manufacturer_ref.get().then((snapshot) => {
          const data = snapshot.data()
          if (!data) return ''
          return data.name
        })
        setStoreName(`${data.name}（${manufacturerName}）`)
      } else {
        setStoreName(data.name)
      }
    })
  }, [switchingStoreRef])
  return storeName
}

export default useSwitchStoreName
